import { curry } from "ramda";
import accounting from "accounting";
import { isValidValue, valueBearing } from "utils/validation";
export var replaceDots = function replaceDots(str) {
  if (!isValidValue(str)) return "";
  return str.toString().replace(/[0-9]\.[0-9]/g, function (x) {
    return x.replace(".", ",");
  });
};
export var formatKr = function formatKr(kr) {
  return accounting.formatNumber(kr, 0, " ");
};
export var format = curry(function (unit, d) {
  if (!isValidValue(d) || d === "-") return "-";
  switch (unit) {
    case "Kronor":
      return replaceDots(valueBearing(d) ? formatKr(d) : d);
    case "%":
    case "Procentuell avvikelse från rikssnitt":
      return replaceDots(valueBearing(d) ? "".concat(d, "\xA0%") : d);
    default:
      return replaceDots(d);
  }
});
export var ellipsis = function ellipsis(length, d) {
  return d.toString().length > length ? "".concat(d.toString().substr(0, length - 2), "..") : d;
};